import { defineCustomElement } from 'vue';
import { initAssetServer } from './__webpack_public_path__';

initAssetServer();

import App from './App.ce.vue';

window.customElements.define('emh-stage-campaign', defineCustomElement(App));
